import SideNavBar from './SideNavBar';
import SideNavBarContainer from './SideNavBar.container';

export default SideNavBarContainer(SideNavBar);
